import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { MobileHamburgerMenu } from '../utils'

const DesktopMegaMenu = dynamic(
  () => import('components/navigation/desktop-mega-menu'),
  { ssr: false, loading: () => null },
)

// Match scss/_variables.scss. Mount only one menu so resizing does not leave
// hidden drawers, focus targets or duplicate navigation requests behind.
export const DESKTOP_MENU_QUERY = '(min-width: 992px)'

const NavigationMenu = ({ isSearchBarActive }) => {
  const [isDesktop, setIsDesktop] = useState(null)

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_MENU_QUERY)
    const update = () => setIsDesktop(media.matches)
    update()
    media.addListener(update)
    return () => media.removeListener(update)
  }, [])

  if (isDesktop === null) return null
  return isDesktop ? (
    <DesktopMegaMenu isSearchBarActive={isSearchBarActive} />
  ) : (
    <MobileHamburgerMenu />
  )
}

NavigationMenu.propTypes = { isSearchBarActive: PropTypes.bool }
NavigationMenu.defaultProps = { isSearchBarActive: false }

export default NavigationMenu
